import React, { useState, useEffect } from 'react';
import authService from '../services/authService';
import agentService from '../services/agentService';
import Settings from './Settings';
import Secrets from './Secrets';
import Agents from './Agents';
import ExternalMcpServers from './ExternalMcpServers';
import BedrockChat from './BedrockChat';
import './Dashboard.css';

// URLs should be configured from environment or CDK outputs
const AGENT_PARENT_API_URL = process.env.REACT_APP_AGENT_PARENT_API_URL || 'https://your-agent-parent-api-url.execute-api.us-east-1.amazonaws.com/prod';

function Dashboard({ authResult, onSignOut }) {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isSecretsOpen, setIsSecretsOpen] = useState(false);
  const [isAgentsOpen, setIsAgentsOpen] = useState(false);
  const [isExternalMcpServersOpen, setIsExternalMcpServersOpen] = useState(false);

  return (
    <div className="dashboard-container">
      <BedrockChat 
        authResult={authResult}
        onOpenSettings={() => setIsSettingsOpen(true)}
        onOpenSecrets={() => setIsSecretsOpen(true)}
        onOpenAgents={() => setIsAgentsOpen(true)}
        onOpenExternalMcpServers={() => setIsExternalMcpServersOpen(true)}
        onAgentsClose={() => setIsAgentsOpen(false)}
        onSignOut={onSignOut}
      />

      <Settings 
        isOpen={isSettingsOpen}
        onClose={() => setIsSettingsOpen(false)}
        authResult={authResult}
      />

      <Secrets 
        isOpen={isSecretsOpen}
        onClose={() => setIsSecretsOpen(false)}
      />

      <Agents 
        isOpen={isAgentsOpen}
        onClose={() => {
          setIsAgentsOpen(false);
          // Notify BedrockChat to reload agent tools
          window.dispatchEvent(new Event('agentsUpdated'));
        }}
      />

      <ExternalMcpServers 
        isOpen={isExternalMcpServersOpen}
        onClose={() => setIsExternalMcpServersOpen(false)}
      />
    </div>
  );
}

export default Dashboard;
